import React from "react";
import { TextField } from "@mui/material";

export function Input({ required, label, InputLabelProps, ...rest }) {

  const labelAsterisco = required && label ? (
    <>
      {label} <span style={{ color: '#666666' }}>*</span>
    </>
  ) : label;
  
  return (
    <TextField 
      label={labelAsterisco}
      InputLabelProps={{
        ...InputLabelProps,
        required: false,
      }}
      {...rest} 
    />
  );
}
